/* 
	<template>
		// 使用state标签，定义字典名称dict、值value
		<c-state dict="dictName" value="1"></c-state>
		// 使用异步数据定义async属性
		<c-state dict="dictName" async value="1"></c-state>
		
		// 下拉框、单复选框直接使用下面引入的选项数据
		<c-select :options="dictName"></c-select>
		<c-radio-group :options="dictName"></c-radio-group>
		<c-checkbox-group :options="dictName"></c-checkbox-group>
	</template>

	<script>
		// 获取本地选项数据
		// 导入mapState方法
		import {mapState} from 'vuex'
		export default {
			computed: {
				// 获取dictName选项数据
				...mapState(['dictName'])
			}
		}
		
		// 获取异步选项数据
		// 导入asyncMapState方法
		import {asyncMapState} from '@/store'
		export default {
			computed: {
				// 获取dictName选项数据
				...asyncMapState(['dictName'])
			}
		}
	</script>
 */

/* 支持颜色
 * gray 灰色
 * blue 蓝色
 * red 红色
 * green 绿色
 * yellow 黄色
 * orange 橙色
 */

export default {
	// 是/否
	enableDic: [{
		name: '是',
		value: 1,
		color: 'green'
	}, {
		name: '否',
		value: 0,
		color: 'gray'
	}],
	// 启用/停用
	disableEnableDic: [{
		name: '启用',
		value: 1,
		color: 'green'
	}, {
		name: '禁用',
		value: 2,
		color: 'gray'
	}],
	// 普通商户/行业模版
	saasTypeDic: [{
		name: '商户',
		value: 2
	},{
		name: '行业方案',
		value: 1,
		color: 'red'
	}],
	// 专业版/免费版
	vipDic: [{
		name: '免费版',
		value: 2
	},{
		name: '专业版',
		value: 1,
		color: 'goldenrod'
	}],
	//销售商品总体状态（对应 SaleProductOverallStateEnum / tbl_sale_product.overall_state，与 PC/H5 端 saleOverallStateDic 同义同值）
	saleOverallStateDic: [{
		name: '待上架',
		value: 1,
		color: 'yellow'
	}, {
		name: '已上架',
		value: 2,
		color: 'green'
	}, {
		name: '已下架',
		value: 3,
		color: 'gray'
	}, {
		name: '锁定中',
		value: 4,
		color: 'red'
	}, {
		name: '已售出',
		value: 5,
		color: 'green'
	}],
	//商品主状态（对应 tbl_product.state，与 PC 端 productStateDic 同义同值）
	productStateDic: [{
		name: '待绑定',
		value: 0,
		color: 'gray'
	}, {
		name: '采购待入库',
		value: 1,
		color: 'green'
	}, {
		name: '销售退货待入库',
		value: 2,
		color: 'blue'
	}, {
		name: '在库',
		value: 10,
		color: 'gray'
	}, {
		name: '质检调拨中',
		value: 11,
		color: 'blue'
	}, {
		name: '质检中',
		value: 12,
		color: 'green'
	}, {
		name: '质检调拨返库中',
		value: 13,
		color: 'blue'
	}, {
		name: '质检驳回返库中',
		value: 14,
		color: 'red'
	}, {
		name: '质检驳回中',
		value: 16,
		color: 'red'
	}, {
		name: '维修调拨中',
		value: 21,
		color: 'blue'
	}, {
		name: '维修中',
		value: 22,
		color: 'green'
	}, {
		name: '维修返库中',
		value: 23,
		color: 'blue'
	}, {
		name: '维修驳回返库中',
		value: 24,
		color: 'red'
	}, {
		name: '维修驳回中',
		value: 26,
		color: 'red'
	}, {
		name: '销售调拨中',
		value: 31,
		color: 'blue'
	}, {
		name: '销售中',
		value: 32,
		color: 'green'
	}, {
		name: '销售返库中',
		value: 33,
		color: 'blue'
	}, {
		name: '销售驳回返库中',
		value: 34,
		color: 'red'
	}, {
		name: '销售驳回中',
		value: 36,
		color: 'red'
	}, {
		name: '采购退库',
		value: 41,
		color: 'gray'
	}, {
		name: '销售出库',
		value: 42,
		color: 'green'
	}, {
		name: '分润调拨出库',
		value: 43,
		color: 'blue'
	}],
	//推送状态（销售推送记录弹窗，与商家端 salePushStateDic 同义同值）
	salePushStateDic: [{
		name: '待推送',
		value: 1,
		color: 'gray'
	}, {
		name: '已受理',
		value: 2,
		color: 'orange'
	}, {
		name: '推送失败',
		value: 3,
		color: 'red'
	}, {
		name: '推送成功',
		value: 4,
		color: 'green'
	}, {
		name: '已撤销',
		value: 5,
		color: 'gray'
	}],
	//推送类型（销售推送记录弹窗，与后端 PushTypeEnum 同口径：push_type 沿用 sync_type 取值）
	salePushTypeDic: [{
		name: '发布',
		value: 1,
		color: 'blue'
	}, {
		name: '上架',
		value: 2,
		color: 'green'
	}, {
		name: '下架',
		value: 3,
		color: 'gray'
	}, {
		name: '调价',
		value: 4,
		color: 'orange'
	}, {
		name: '信息更新',
		value: 5,
		color: 'gray'
	}, {
		name: '售出下架',
		value: 6,
		color: 'red'
	}, {
		name: '锁单下架',
		value: 7,
		color: 'red'
	}, {
		name: '售后退货退款',
		value: 8,
		color: 'red'
	}],
	//借出归还状态（销售借出记录弹窗，与商家端 saleReturnStateDic 同义同值）
	saleReturnStateDic: [{
		name: '借出中',
		value: 1,
		color: 'orange'
	}, {
		name: '已归还',
		value: 2,
		color: 'green'
	}],
	//推送状态（推送记录 push_state）
	PUSH_STATE: [{
		name: '待推送',
		value: 1
	}, {
		name: '已受理',
		value: 2
	}, {
		name: '推送失败',
		value: 3,
		color: 'red'
	}, {
		name: '推送成功',
		value: 4,
		color: 'green'
	}, {
		name: '已撤销',
		value: 5,
		color: 'gray'
	}],
	//同步任务类型（推送记录 push_type）
	SYNC_TYPE: [{
		name: '发布',
		value: 1
	}, {
		name: '上架',
		value: 2
	}, {
		name: '下架',
		value: 3
	}, {
		name: '调价',
		value: 4
	}, {
		name: '信息更新',
		value: 5
	}, {
		name: '售出下架',
		value: 6
	}, {
		name: '锁单下架',
		value: 7
	}, {
		name: '售后退货退款',
		value: 8
	}],
	//上架渠道类型（sale_channel_type：1暗拍渠道/2靓机渠道）
	saleChannelTypeDic: [{
		name: '暗拍渠道',
		value: 1,
		color: 'blue'
	}, {
		name: '靓机渠道',
		value: 2,
		color: 'green'
	}],
	//销售状态
	salesStateDic: [{
		name: '待跟进',
		value: 1,
		color: 'yellow'
	},{
		name: '跟进中',
		value: 2,
		color: 'red'
	},{
		name: '已合作',
		value: 3,
		color: 'green'
	},{
		name: '无意向',
		value: 4,
		color: 'gray'
	},{
		name: '渠道',
		value: 5,
		color: 'blue'
	},{
		name: '其他',
		value: 6,
		color: ''
	}],
	dateRangDic: [{
		name: '今日',
		value: 1
	},{
		name: '3天内',
		value: 3
	},{
		name: '7天内',
		value: 7
	},{
		name: '15天内',
		value: 15
	},{
		name: '30天内',
		value: 30
	}],
	registerSourceDic: [{
		name: '电脑端',
		value: 0,
		color: 'brown'
	},{
		name: '移动端',
		value: 1,
		color: 'blue'
	},{
		name: '管理后台',
		value: 2,
		color: 'green'
	}],
	printTypeDic:[{
		name: '浏览器原生打印',
		value: 1,
		color: 'green'
	},{
		name: 'Lodop控件打印',
		value: 2,
		color: 'blue'
	}],
	batchStockDic:[{
		name: '常规库存模式',
		value: 0,
		color: 'green'
	},{
		name: '批次库存模式',
		value: 1,
		color: 'blue'
	}],
	appHomeTypeDic:[{
		name: '单页打开',
		value: 0,
		color: 'green'
	},{
		name: '弹框打开',
		value: 1,
		color: 'blue'
	}],
	attributeTypeOptions:[
		{name: '选项',value: 4, color: 'green'},
		{name: '文本',value: 1, color: 'orange'},
		{name: '数字',value: 2, color: 'brown'},
		{name: '时间',value: 3, color: 'blue'}
		/*{name: '附件',value: 5, color: 'blue'},
		{name: '图片',value: 6, color: 'blue'},
		{name: '其他',value: 7, color: 'blue'},*/
	],
	timeFormatOptions: [{
		name: '年-月-日',
		value: 'yyyy-MM-dd|date'
	}, {
		name: '年-月-日 时',
		value: 'yyyy-MM-dd hh|datetime|hour'
	}, {
		name: '年-月-日 时:分',
		value: 'yyyy-MM-dd hh:mm|datetime|min'
	}, {
		name: '年-月-日 时:分:秒',
		value: 'yyyy-MM-dd hh:mm:ss|datetime|sec'
	}, {
		name: '时:分:秒',
		value: 'hh:mm:ss|time|sec'
	}],
	yesOrNoOptions:[
		{name: '是',value: 1, color: 'green'},
		{name: '否',value: 2, color: ''},
	],
	orderPayTypeOptions:[
		{name: '通联支付',value: 1, color: 'green'},
		{name: '三方渠道支付',value: 2, color: ''},
		{name: '其他支付方式',value: 3, color: ''},
		{name: '授信支付',value: 4, color: ''}
	]
}